import React, { useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Paper,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import CommonForm from "../../utils/components/commonForm";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";
import moment from "moment";
import Backdrop from "@mui/material/Backdrop";
import axios from "axios";
import { ContactlessOutlined } from "@mui/icons-material";

let baseCount = 80000;
const EditForms = () => {
  const [inputStates, setInputStates] = React.useState({
    competentPerson: 12,
  });
  const [inputFields, setInputFields] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { reportID, templateID } = useParams();
  const [templateData, setTemplateData] = React.useState({});

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const submitReport = async () => {
    try {
      const formConfigJson = JSON.stringify({
      ...inputStates,
      ...(templateID == 5 && { checkedPoints: inputStates?.checkedPoints || "" }),
    });

      if (formConfigJson) {
        const reportData =
          reportID < 1
            ? {
                templateId: templateID,
                templateValues: formConfigJson,
                reportNo: inputStates?.reportNumber,
              }
            : {
                templateValues: formConfigJson,
                approvedBy: null,
                reportNo: inputStates?.reportNumber,
              };

        const reportEndpoint =
          reportID < 1
            ? BASE_URL + "reportValues"
            : BASE_URL + `reportValues/${reportID}`;

        const reportResponse = await (reportID < 1
          ? axiosWithToken.post(reportEndpoint, reportData)
          : axiosWithToken.patch(reportEndpoint, reportData));

        toast(
          reportResponse.status === 200
            ? "Report created/updated successfully!"
            : "Failed to create/update Report."
        );
        if (reportResponse.status === 200) {
          setTimeout(refresh, 500);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    }
  };

  const fetchformReport = async (id) => {
    setLoading(true);
    try {
      const res = await axiosWithToken.get(`${BASE_URL}reportValues/${id}`);
      const data = res.data[0];

      if (!data || !data.templateValues) {
        console.log("Template data not found or invalid");
        return;
      }

      const dataObject = data.templateValues && JSON.parse(data.templateValues);

      const newDataObject = { ...dataObject };
      // delete newDataObject.reportDate;
      setInputStates(newDataObject);
    } catch (error) {
      console.error("Failed to fetch template: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTemplate = (id) => {
    try {
      setLoading(true);
      let SQLQuery = {
        query: `SELECT templates.*, branch.name AS branchName FROM templates LEFT JOIN branch ON templates.branchId = branch.id WHERE templates.id = ${id}`,
      };
      axiosWithToken
        .post(BASE_URL + `dynamic`, SQLQuery)
        .then((res) => {
          let data = res.data[0];
          setTemplateData(data);
          axios.get(data?.url).then((respose) => {
            setInputFields(respose.data);
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch checklist template: ", e);
    }
  };

  const fetchAddress = (id) => {
    try {
      let SQLQuery = {
        query: `SELECT a.address, c.occupierName FROM addresses a left JOIN clients c ON SUBSTRING_INDEX(c.address, ',', 1) = a.id WHERE c.id = ${id}`,
      };
      setLoading(true);
      axiosWithToken
        .post(BASE_URL + `dynamic`, SQLQuery)
        .then((res) => {
          let data = res.data[0];
          setInputStates((prevState) => ({
            ...prevState,
            addressFactory: data?.address,
            Occupier: data?.occupierName,
          }));
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch checklist template: ", e);
    }
  };

  var refresh = () => {
    window.location.reload(false);
  };

  const fetchPreviousReportNumber = (templateID) => {
    templateID = Number(templateID);
    try {
      let prefix = "";
      switch (templateID) {
        case 1: // SECTION 28
          prefix = "HTG28";
          break;
        case 2: // SECTION 29
          prefix = "HTG29";
          break;
        case 3: // FORM-8
          prefix = "HTG8";
          break;
        case 4: // STORAGE TANKS
          prefix = "HTGST";
          break;
        case 5: // CENTRIFUGAL MACHINES
          prefix = "HTG21";
          break;
        default:
          prefix = "HTG"; // fallback prefix
          break;
      }
        let SQLQuery = {
        query: `SELECT JSON_UNQUOTE(JSON_EXTRACT(templateValues, '$.reportNumber')) AS reportNumber FROM reportValues WHERE templateId = ${templateID} ORDER BY id DESC LIMIT 1`,
      };

      axiosWithToken.post(BASE_URL + `dynamic`, SQLQuery).then((res) => {
        let oldReportNumber = res?.data[0]?.reportNumber;
        // Validate oldReportNumber
        if (!oldReportNumber || oldReportNumber.includes("undefined") || oldReportNumber.includes("NaN")) {
          oldReportNumber = prefix + '00000'; // start from 0001
        }

        const oldNumberPart = oldReportNumber.replace(prefix, '');
        const incrementedNumber = (parseInt(oldNumberPart, 10) + 1)
          .toString()
          .padStart(5, "0"); // always 5 digits!

        const newReportNumber = prefix + incrementedNumber;
        setInputStates((prevInputStates) => ({
          ...prevInputStates,
          reportNumber: newReportNumber,
        }));
      });
    } catch (e) {
      console.log("Failed to fetch Previous ReportNumber: ", e);
    }
  };

  useEffect(() => {
    if (reportID < 1) {
      setInputStates((prev) => ({
        ...prev,
        reportStateName: templateData?.branchName,
      }));
    }
  }, [templateData?.branchName]);

  useEffect(() => {
    // if (reportID < 1) {
      const calculateCertificateValidity = () => {
      let reportDate = moment(inputStates?.reportDate);

        if (inputStates?.renewal === 1) {
          reportDate = reportDate.add(1, "year");
        } else if (inputStates?.renewal === 2) {
          reportDate = reportDate.add(6, "months");
        } else if (inputStates?.renewal === 3) {
          reportDate = reportDate.add(2, "year");
        } else if (inputStates?.renewal === 4) {
          reportDate = reportDate.add(4, "year");
        }

        return reportDate.subtract(1, "day").format("YYYY-MM-DD");
      };

      setInputStates((prev) => ({
        ...prev,
        certifyDate: inputStates?.reportDate,
        certificateValidity: inputStates?.renewal
          ? calculateCertificateValidity()
          : inputStates?.reportDate,
      }));
    // }
  }, [inputStates?.reportDate, inputStates?.renewal]);

  useEffect(() => {
    if (reportID == 0) {
      fetchPreviousReportNumber(templateID);
    }
  }, [templateID]);

  useEffect(() => {
    if (inputStates?.factoryId) fetchAddress(inputStates?.factoryId);
  }, [inputStates?.factoryId]);

  useEffect(() => {
    if (templateID > 0) {
      fetchTemplate(templateID);
    }
    if (reportID > 0) {
      fetchformReport(reportID);
    }
  }, [reportID, templateID]);

  return (
    <>
      <Paper sx={{ mt: 2, p: 4 }}>
        <CommonForm
          inputStates={inputStates}
          updateInputObject={updateInputObject}
          inputFields={inputFields}
          isTemplateForm={true}
        />
        {templateID == 5 && (
          <Box mt={2}>
            <Typography sx={{textAlign:"left"}} variant="h6" fontWeight="bold">
              Following Points have been checked:
            </Typography>
            <TextField
              label="Details"
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              value={inputStates?.checkedPoints || 
              `1. Machine Placed on proper foundations and no abnormal vibrations observed.\n2. The clamping unit and other accessible parts were found guarded. Wherever necessarily, warning signs were given.\n3. The machine is provided with two push buttons to start the operation as to engage both hands of operator, while pressing operation.\n4. Machine Safety Interlocking checked by obstructing the safety sensors during running of the machine and found the machine stopped in that case.\n5. Functioning of Hydraulic System components like Non-Return Valves, Check valves, Direction Control Valves found OK, during Safety Interlocking Testing.\n6. All Pressure Parts are checked for any kind of abnormality and found OK.\n7. Machine Positioning Switches & Sensors Monitored during Machine Running and found working Ok at the time of operation of the machine.\n8. During Examination, I/we found No Safety has been Bypassed and there were no modification was done in machine by the user.`
            }
              onChange={(e) =>
                updateInputObject("checkedPoints", e.target.value)
              }
              sx={{ mt: 2 }}
            />
          </Box>
        )}

        <Toolbar
          style={{
            padding: "0px",
            overflow: "auto",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            onClick={() => {
              submitReport();
            }}
          >
            {reportID > 0 ? "Update" : "Save"}
          </Button>
        </Toolbar>
        <Modal
          open={loading}
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Box
            style={{
              width: "100%",
              height: "100vh",
              bgcolor: "background.paper",
              border: "2px solid cadetblue",
              padding: "30px",
              textAlign: "center",
              display: "grid",
              placeItems: "center",
            }}
          >
            <CircularProgress color="secondary" size={200} />
          </Box>
        </Modal>
      </Paper>
    </>
  );
};

export default EditForms;
